
import { defineComponent } from 'vue'
import { iOlapFilter } from '@/modules/documentExecution/olap/Olap'
import toolbarDescriptor from './OlapFilterToolbarDescriptor.json'

export default defineComponent({
    components: {},
    props: { olapProp: { type: Object, required: true } },
    emits: ['openSidebar', 'putFilterOnAxis', 'switchPosition', 'showMultiHierarchy', 'openFilterDialog'],
    computed: {
        showScroll(): Boolean {
            return this.scrollContainerHeight < this.scrollContentHeight
        }
    },
    data() {
        return {
            toolbarDescriptor,
            columns: [] as iOlapFilter[],
            rows: [] as iOlapFilter[],
            cutArray: [12, 11, 10, 9, 6],
            scrollContainerHeight: 0,
            scrollContentHeight: 0
        }
    },
    watch: {
        olapProp() {
            this.loadData()
        }
    },
    created() {
        this.loadData()
        window.addEventListener('resize', this.assignScrollValues)
        this.assignScrollValues()
    },
    methods: {
        loadData() {
            this.columns = this.olapProp?.columns as iOlapFilter[]
            this.rows = this.olapProp?.rows as iOlapFilter[]
        },
        cutName(name, axis, multi) {
            var ind = axis
            if (multi) ind = ind + 2
            ind = ind + 1
            var cutProp = this.cutArray[ind]
            if (name == undefined) {
                name = '...'
            }
            if (name.length <= cutProp) return name
            else return name.substring(0, cutProp) + '...'
        },
        onDragStart(event, filter, filterId) {
            event.dataTransfer.setData('text', JSON.stringify(filter))
            event.dataTransfer.dropEffect = 'move'
            event.dataTransfer.effectAllowed = 'move'
            // @ts-ignore
            this.$refs[`${filterId}`].classList.add('filter-dragging')
        },
        removeDragClass(filterId) {
            // @ts-ignore
            this.$refs[`${filterId}`].classList.remove('filter-dragging')
        },
        displayDropzone() {
            // @ts-ignore
            this.$refs.axisDropzone.classList.add('display-axis-dropzone')
        },
        hideDropzone() {
            // @ts-ignore
            this.$refs.axisDropzone.classList.remove('display-axis-dropzone')
        },
        onDrop(event) {
            console.log('DROPPED _-----------------------')
            // @ts-ignore
            this.$refs.axisDropzone.classList.remove('display-axis-dropzone')
            var data = JSON.parse(event.dataTransfer.getData('text/plain'))

            var leftLength = this.rows.length
            var topLength = this.columns.length
            var fromAxis
            if (data != null) {
                fromAxis = data.axis
                if (fromAxis != 1) {
                    if (data.axis === 0 && topLength == 1) {
                        this.$store.commit('setInfo', { title: this.$t('common.toast.warning'), msg: this.$t('documentExecution.olap.filterToolbar.dragEmptyWarning') })
                    } else {
                        data.positionInAxis = leftLength
                        data.axis = 1
                        this.$emit('putFilterOnAxis', fromAxis, data)
                    }
                }
            }
            setTimeout(() => {
                this.assignScrollValues()
            }, 100)
        },
        scrollUp() {
            // @ts-ignore
            this.$refs.filterItemsContainer.scrollTop -= 50
        },
        scrollDown() {
            // @ts-ignore
            this.$refs.filterItemsContainer.scrollTop += 50
        },
        assignScrollValues() {
            console.log('CALLED ASSING VALUES --------------------------------')
            // @ts-ignore
            this.scrollContainerHeight = this.$refs?.filterPanelContainer?.clientHeight
            // @ts-ignore
            this.scrollContentHeight = this.$refs?.filterItemsContainer?.scrollHeight
        },
        openFilterDialog(filter: any) {
            this.$emit('openFilterDialog', { filter: filter, type: 'visible' })
        }
    }
})
